module.exports = __webpack_public_path__ + "static/grafika5-4c4c56313356c07a2e22688490f330ae.png";